import { ShieldCheck } from 'lucide-react';
import { Icon, Select } from '@vizial-ui/components';

import { TENANT_OPTIONS } from '../AppShell/utils/tenantOptions';
import styles from './TenantSwitcher.module.css';

export function TenantSwitcher() {
  return (
    <div className={styles.section}>
      <Icon icon={ShieldCheck} iconSize="sm" className={styles.label}>
        Admin – Viewing as
      </Icon>
      <Select
        className={styles.select}
        size="sm"
        options={TENANT_OPTIONS}
        defaultValue="security-customer-a"
        aria-label="Tenant selector"
      />
    </div>
  );
}
